import React from 'react';
import { Helmet } from 'react-helmet';

type MetaData =
  | { name: string; content: any; property?: undefined }
  | { property: string; content: any; name?: undefined };

interface SEOProps {
  title: string;
  description: string;
  lang?: string;
  meta?: MetaData[];
  site?: string;
}

const SEO: React.FC<SEOProps> = ({ description = '', lang = 'en', meta = [], title = '', site = '' }) => {
  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[{ name: `description`, content: description } as MetaData].concat(
        meta
      )}
    />
  );
};

export default SEO;
